// extracted by mini-css-extract-plugin
module.exports = {"card":"ClientCabinet_card_2IvLa","license-active":"ClientCabinet_license-active_1LgAH","spin":"ClientCabinet_spin_3HAq4"};